export default __webpack_public_path__ + "static/notary-banner-4f1a6f5628a3ff3f83d0cc145c583b01.jpg";